import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AppStore from '../../store/AppStore'
import { push } from 'react-router-redux'
import { Toastr } from 'react-aquasys'
import { PATH_HOME } from '../../home/constants/HomeConstants'
import SignIn from './SignIn'
import CookiePanel from '../../components/cookie/CookiePanel'

class LoginApp extends Component {
	componentWillMount() {
		const token = sessionStorage.getItem('TOKEN')
		if (token && atob(token)) {
			AppStore.dispatch(push(PATH_HOME))
		}
	}

	render() {
		return (
			<div id='login-page'>
				<div className='container-div valign-wrapper'>
					<div className='container-panel'>
						<div className='container'>
							<div className='row'>
								<div className='col s6 m6 l4 offset-m3 offset-l4'>
									<div className='row'>
										<SignIn/>
										<CookiePanel/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Toastr store={ AppStore }/>
			</div>
		)
	}
}

LoginApp.propTypes = {
	error: PropTypes.string,
	success: PropTypes.string
}

const mapStateToProps = store => {
	return {
		error: store.LoginReducer.error,
		success: store.LoginReducer.success
	}
}

export default connect(mapStateToProps)(LoginApp)



// WEBPACK FOOTER //
// ./src/login/components/LoginApp.js